;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { ReactNode, SVGProps } from 'react'

type IconProps = {
  title?: string
} & Pick<SVGProps<SVGElement>, 'className' | 'viewBox' | 'aria-hidden'>

type IconBaseProps = {
  path: ReactNode
} & IconProps

const IconBase = ({
  title,
  path,
  className,
  viewBox,
  'aria-hidden': ariaHidden,
}: IconBaseProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox={viewBox}
    width="24px"
    fill="#FFFFFF"
    role="img"
    aria-hidden={ariaHidden}
  >
    <>
      {title ? <title>{title}</title> : null}
      {path}
    </>
  </svg>
)

export const createIcon = (
  path: ReactNode,
  displayName: string,
  viewBox = '0 0 24 24',
) => {
  const Icon = ({ title, className, 'aria-hidden': ariaHidden }: IconProps) => (
    <IconBase
      title={title}
      path={path}
      className={className}
      viewBox={viewBox}
      aria-hidden={ariaHidden}
    />
  )
  Icon.displayName = displayName
  return Icon
}
